import { render, staticRenderFns } from "./Reservasi.vue?vue&type=template&id=14ba9f8a&scoped=true"
import script from "./Reservasi.vue?vue&type=script&lang=js"
export * from "./Reservasi.vue?vue&type=script&lang=js"
import style0 from "./Reservasi.vue?vue&type=style&index=0&id=14ba9f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ba9f8a",
  null
  
)

export default component.exports